import PropTypes from 'prop-types';
import AmountWithCurrency from '../../common/AmountWithCurrency';
import CustomInput from '../CustomInput';
import ErrorContainer from '../ErrorContainer';
import { Store } from '@mui/icons-material';

const TransferForm = ({
    formData,
    fieldError,
    balancesCurrencies,
    handleAmountChange,
    handleEmailChange,
    handleReferenceChange,
    handleCurrencyChange,
    selectedMerchant,
    dataE2eModal,
}) => {
    return (
        <>
            <div className="flex flex-col items-center w-full rounded-lg">
                <AmountWithCurrency
                    errorMessage={fieldError.currency || fieldError.amount}
                    transactionLabel="CURRENCY"
                    data={balancesCurrencies || []}
                    amountValue={formData.amount || ''}
                    selected={formData.currency}
                    onAmountChange={e => handleAmountChange('amount', e.target.value)}
                    onCurrencyChange={val => handleCurrencyChange(val)}
                    isRequired={true}
                    dataE2e={dataE2eModal || 'transfer-form'}
                />

                {selectedMerchant && Object.keys(selectedMerchant).length > 0 ? (
                    <div className="mt-6 w-full">
                        <p className="block text-xs text-balanceCard-manage mb-2 uppercase tracking-wide w-full text-start">
                            Sending to
                            <span className="required">*</span>
                        </p>
                        <div className="w-full flex items-center gap-2 uppercase bg-card-bg rounded-md text-sm font-medium py-2 px-3 h-12 text-text">
                            {selectedMerchant.merchantLogo ? (
                                <img
                                    src={selectedMerchant.merchantLogo}
                                    alt={`${selectedMerchant.merchantName} Logo`}
                                    className="rounded-full w-8 h-8"
                                />
                            ) : (
                                <div className="w-8 h-8 !bg-[#D1D1D6] dark:!bg-[#51525C] rounded-full flex justify-center items-center cursor-pointer ">
                                    <Store fontSize="medium" className="!text-primary" />
                                </div>
                            )}
                            <h1 className="">{selectedMerchant.merchantName}</h1>
                        </div>
                    </div>
                ) : (
                    <div className="flex flex-col w-full gap-1">
                        <CustomInput
                            label="Email Address"
                            type="email"
                            name="email"
                            placeholder="enter email address"
                            value={formData.email}
                            onChange={e => handleEmailChange(e.target.value)}
                            disabled={false}
                            dataE2e={dataE2eModal || 'transfer-form'}
                        />
                        {fieldError.email && (
                            <ErrorContainer id="email-error" message={fieldError.email} />
                        )}
                    </div>
                )}

                <div className="w-full">
                    <CustomInput
                        label="Reference"
                        type="text"
                        name="reference"
                        placeholder="enter your reference"
                        value={formData.reference}
                        onChange={e => handleReferenceChange(e.target.value)}
                        disabled={false}
                    />
                </div>
            </div>
        </>
    );
};

TransferForm.propTypes = {
    formData: PropTypes.shape({
        currency: PropTypes.shape({
            currencyShortName: PropTypes.string,
        }),
        email: PropTypes.string,
        amount: PropTypes.string,
        reference: PropTypes.string,
    }),
    fieldError: PropTypes.shape({
        currency: PropTypes.string,
        email: PropTypes.string,
        amount: PropTypes.string,
        reference: PropTypes.string,
    }),
    handleAmountChange: PropTypes.func.isRequired,
    handleEmailChange: PropTypes.func.isRequired,
    handleReferenceChange: PropTypes.func.isRequired,
    handleCurrencyChange: PropTypes.func.isRequired,
    balancesCurrencies: PropTypes.array,
    selectedMerchant: PropTypes.object,
};

export default TransferForm;
